import { createSelector } from 'redux-orm';
import { getSecondArgument } from 'consts';
import { orm } from 'model';
import { createCachedSelector } from 're-reselect';
import {
  combinerSelectorArray,
  filterByFSPId,
} from './utils/fspConfigPayALoan';

const baseSelector = createSelector(orm, getSecondArgument, filterByFSPId);

// eslint-disable-next-line import/prefer-default-export
export const selector = createCachedSelector(
  baseSelector,
  combinerSelectorArray
)(getSecondArgument);
